export default function wow() {
  new WOW({
    animateClass: 'animate__animated',
    mobile: false,
  }).init()
}